<template>
    <div id="inquiry-page">
        <!-- HEADER -->
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="$vuetify.lang.t('$vuetify.billboard.searchByTopic')"
                        solo
                        height="40px"
                        @keyup.enter="getBillboardsPagination()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        @click="searchMessage()"
                        height="40px"
                        color="primary"
                        outlined>
                        {{ $vuetify.lang.t('$vuetify.billboard.search') }}
                    </v-btn>
                </div>

                <div class="ml-day-message">
                    <v-menu
                        v-model="startDatePickerShow"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="startDateFormatted"
                                :label="$vuetify.lang.t('$vuetify.billboard.startDate')"
                                prepend-inner-icon="event"
                                solo
                                height="40px"
                                background-color="#ffffff"
                                @click:prepend-inner="startDatePickerShow = true"
                                readonly
                                v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker
                            :locale="localeLang"
                            v-model="startDate"
                            @change="formatStartDate"
                            @input="startDatePickerShow = false">
                        </v-date-picker>
                    </v-menu>
                </div>

                <div class="ml-day-message">
                    <v-menu
                        v-model="endDatePickerShow"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="endDateFormatted"
                                :label="$vuetify.lang.t('$vuetify.billboard.endDate')"
                                prepend-inner-icon="event"
                                solo
                                height="40px"
                                background-color="#ffffff"
                                @click:prepend-inner="endDatePickerShow = true"
                                readonly
                                v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker
                            :locale="localeLang"
                            v-model="endDate"
                            @change="formatEndDate"
                            @input="endDatePickerShow = false">
                        </v-date-picker>
                    </v-menu>
                </div>
            </div>
                <v-btn
                    class="ml-3"
                    @click="createMessage()"
                    height="40"
                    color="primary">
                    + {{ $vuetify.lang.t('$vuetify.billboard.createMessage') }}
                </v-btn>
        </div>
        <!-- END HEADER -->

        <message-modal
            ref="modalMessage"
            :updateMessageId="updateMessageId"
            :typeMessage="typeMessage"
            @success-saved="messageSuccess()"
            @close-modal="closeModal()"
            :mode="operationMode"/>

        <delete-modal
            ref="modalDelete"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>

        <!-- DATATABLE -->
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalData"
                :items="items"
                :loading="loading">
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action">
                        <v-icon
                            @click="updateMessage(item.id)"
                            class="mr-2">
                            edit
                        </v-icon>
                        <v-icon
                            @click="deleteMessage(item)"
                            class="mr-2">
                            delete
                        </v-icon>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <!-- END DATATABLE -->

        <!-- PAGINATION -->
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>
        <!-- END PAGINATION -->
    </div>
</template>

<script>
import permissionConstant from '@/constants/permissions.js'
import MessageModal from '@/components/modal/MessageModal'
import DeleteModal from '@/components/modal/DeleteModal'

export default {
    name: 'Billboard',

    components: {
        MessageModal,
        DeleteModal
    },
    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.billboard.topic'), value: 'topic', width: '30%' },
                { text: this.$vuetify.lang.t('$vuetify.billboard.startDate'), value: 'start_date', width: '30%' },
                { text: this.$vuetify.lang.t('$vuetify.billboard.endDate'), value: 'end_date', width: '30%' },
                { text: '', value: 'action', width: '10%', sortable: false }
            ]
        },
        questionDelete () {
            return this.$vuetify.lang.t('$vuetify.billboard.questionDelete')
        },
        msgDeleteSuccess () {
            return {
                title: this.$vuetify.lang.t('$vuetify.billboard.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.billboard.msgDeleteSuccess'),
                type: 'success'
            }
        }
    },
    data () {
        return {
            // Filter
            search: '',
            startDate: '',
            endDate: '',
            startDatePickerShow: false,
            endDatePickerShow: false,
            startDateFormatted: '',
            endDateFormatted: '',
            operationMode: '',
            updateMessageId: null,
            typeMessage: 'ANN',

            // Datatable
            pageCount: 1,
            page: 1,
            options: {},
            items: [],
            totalData: 0,
            loading: false,
            branch: null,
            permissionUpdate: false,
            deleteForm: {
                header: '',
                content: '',
                path: ''
            }
        }
    },

    methods: {
        async searchMessage () {
            this.options.page = 1
            await this.getBillboardsPagination()
        },

        async getBillboardsPagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `messages/billboard?branch=${this.branch}&page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            if (this.startDate) {
                url += `&startDate=${this.startDate}`
            }

            if (this.endDate) {
                url += `&endDate=${this.endDate}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.items = res.data.data
                this.totalData = res.data.total
                this.loading = false
            }
        },
        formatStartDate () {
            this.startDateFormatted = this.$util.formatDate(this.startDate)
        },

        formatEndDate () {
            this.endDateFormatted = this.$util.formatDate(this.endDate)
        },

        async getBranch () {
            this.branch = localStorage.getItem('currentBranchId')
            if (this.branch) {
                await this.getBillboardsPagination()
            }
        },

        checkPermission () {
            this.permissionUpdate = this.$util.checkPermission(permissionConstant.billboard.update)
        },

        createMessage () {
            this.operationMode = 'create'
            this.$refs.modalMessage.dialog = true
        },

        updateMessage (messageId) {
            this.operationMode = 'update'
            this.updateMessageId = messageId
            this.$refs.modalMessage.dialog = true
        },

        deleteMessage (item) {
            this.deleteForm.header = this.$vuetify.lang.t('$vuetify.billboard.deleteMessage')
            this.deleteForm.content = this.questionDelete.replace('$Name', item.topic)
            this.deleteForm.path = `message/delete/${item.id}`
            this.$refs.modalDelete.dialog = true
        },

        async deleteSuccess () {
            await this.getBillboardsPagination()
            this.$notify(this.msgDeleteSuccess)
        },

        closeModal () {
            this.operationMode = ''
        },

        async messageSuccess () {
            await this.getBillboardsPagination()
            this.closeModal()
        }
    },

    async mounted () {
        await this.getBranch()
        // this.checkPermission()
    },

    watch: {
        options: {
            async handler () {
                if (this.branch) {
                    await this.getBillboardsPagination()
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
}

::v-deep .search-input .v-input__control > .v-input__slot {
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}

::v-deep .v-input__prepend-inner {
    margin: auto !important;
}

::v-deep .v-input__append-inner {
    margin-top: 0.75rem !important;
}

::v-deep .theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #eeeeee;
    cursor: pointer;
}

.ml-day-message {
    margin-left: 40px;
}

.highlight {
    padding: 0rem 1rem;
    background-color: #ff544a;
    border-radius: 25px;
    color: white;
}

.editable {
    cursor: pointer;
}
</style>
